// Chave de idempotencia para POST /api/rooms/create: gerada uma vez por
// criacao e reenviada nas tentativas seguintes, para que repetir apos uma
// resposta perdida devolva a sala ja criada em vez de duplicar.
export function newIdempotencyKey() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}
